/** Match API /leagues/{id}/teams entries to internal keys like Team1 / Team 2. */

export function normalizeTeamNameForMatch(teamName) {
  if (!teamName) return "";
  return teamName.replace(/\s+/g, "").replace(/\([^)]*\)/g, "").toLowerCase();
}

export function extractTeamNumberFromName(teamName) {
  if (!teamName) return null;
  const match = teamName.match(/team\s*(\d+)/i);
  return match ? parseInt(match[1], 10) : null;
}

export function findTeamByNameInList(teams, targetTeamName) {
  if (!targetTeamName || !teams || teams.length === 0) return null;
  const normalizedTarget = normalizeTeamNameForMatch(targetTeamName);
  const team = teams.find((t) => normalizeTeamNameForMatch(t.name) === normalizedTarget);
  if (team) return team;
  const targetTeamNum = extractTeamNumberFromName(targetTeamName);
  if (targetTeamNum !== null && targetTeamNum >= 1 && targetTeamNum <= teams.length) {
    return teams[targetTeamNum - 1] || null;
  }
  return null;
}
